import { render, staticRenderFns } from "./ModalDependencies.vue?vue&type=template&id=40e8928b&scoped=true"
import script from "./ModalDependencies.vue?vue&type=script&lang=js"
export * from "./ModalDependencies.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40e8928b",
  null
  
)

export default component.exports